import { ResumeAward } from '../../types';

interface AwardsSectionProps {
    awards: ResumeAward[];
    onChange: (awards: ResumeAward[]) => void;
}

const blankAward = (): ResumeAward => ({
    id: crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36),
    title: '',
    organization: '',
    date: '',
    description: '',
    url: '',
});

export function AwardsSection({ awards, onChange }: AwardsSectionProps) {
    const handleChange = (id: string, updates: Partial<ResumeAward>) => {
        onChange(awards.map(award => (award.id === id ? { ...award, ...updates } : award)));
    };

    const handleAdd = () => {
        onChange([...awards, blankAward()]);
    };

    const handleRemove = (id: string) => {
        onChange(awards.filter(award => award.id !== id));
    };

    return (
        <div className="space-y-4">
            <div className="flex items-center justify-between">
                <h3 className="text-lg font-semibold">Awards & Certifications</h3>
                <button
                    type="button"
                    onClick={handleAdd}
                    className="text-sm text-primary-600 hover:text-primary-800"
                >
                    + Add award
                </button>
            </div>

            {awards.map((award, index) => (
                <div key={award.id} className="border border-gray-200 rounded-lg p-3 space-y-2">
                    <div className="flex items-center justify-between">
                        <span className="text-sm text-gray-500">Entry {index + 1}</span>
                        <button
                            type="button"
                            onClick={() => handleRemove(award.id)}
                            className="text-xs text-red-500"
                        >
                            Remove
                        </button>
                    </div>
                    <div className="grid grid-cols-2 gap-2">
                        <input
                            className="input"
                            placeholder="Award / Certification"
                            value={award.title}
                            onChange={(e) => handleChange(award.id, { title: e.target.value })}
                        />
                        <input
                            className="input"
                            placeholder="Organization"
                            value={award.organization || ''}
                            onChange={(e) => handleChange(award.id, { organization: e.target.value })}
                        />
                    </div>
                    <div className="grid grid-cols-2 gap-2">
                        <input
                            type="text" inputMode="numeric" pattern="[0-9]{4}-[0-9]{2}"
                            className="input"
                            placeholder="YYYY-MM"
                            value={award.date || ''}
                            onChange={(e) => handleChange(award.id, { date: e.target.value })}
                        />
                        <input
                            type="url"
                            className="input"
                            placeholder="URL"
                            value={award.url || ''}
                            onChange={(e) => handleChange(award.id, { url: e.target.value })}
                        />
                    </div>
                    <textarea
                        className="textarea"
                        placeholder="Description"
                        rows={2}
                        value={award.description || ''}
                        onChange={(e) => handleChange(award.id, { description: e.target.value })}
                    />
                </div>
            ))}
        </div>
    );
}


